<div style="width: 100%; height: 80%;">
    <div style="display: flex; flex-direction: row; align-items: center; gap:5px; padding: 1rem;">
        <mat-icon  
        style="margin-block: 1rem; cursor: pointer"
        >
        bar_chart
        </mat-icon>
        <h1 style="margin-block: 0;">Resumen del mes</h1>
    </div>
    <ngx-charts-bar-vertical
      [results]="barChartData"
      [xAxis]="true"
      [yAxis]="true"
      [gradient]="false"
      [legend]="true"
      [showXAxisLabel]="true"
      [showYAxisLabel]="true"
      [xAxisLabel]="'Fecha'"
      [yAxisLabel]="'Servicios'"
      [legend]="false"
      style="width: 100%; height: 100%;"
    ></ngx-charts-bar-vertical>
</div>